// extracted by mini-css-extract-plugin
export default {"containerImage":"BannerAbout_containerImage__E24lB","image":"BannerAbout_image__-XIEV","title":"BannerAbout_title__E8FL0"};